import ReportGraph from './ReportGraph';

export default ReportGraph;
